<template>
    <div class="section section-cols">
        <div class="container">
            <div class="row">
                <div class="col d6 md-5 sm-12 section-cols__col section-cols__left">
                    <div class="section-cols__col-inner">
                        <div class="section-cols__media" v-if="params.image">
                            <img :src="params.image" alt="">
                        </div>
                    </div>
                </div>
                <div class="col d6 md-7 sm-12 section-cols__col section-cols__right">
                    <div class="section-cols__col-inner">
                        <div class="section-cols__content" v-if="params.title">
                          <h2 v-if="params.title" v-html="params.title"></h2>
                          <p v-if="params.text" v-html="params.text"></p>
                        </div>
                        <div class="section-cols__actions" v-if="params.btn">
                            <ABtn class="dark" :label="params.btn.text" :href="params.btn.action"/>
                            <ABtn class="dark section-cols__btn-sm d12" :label="params.btn.text_sm" :href="params.btn.action"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { ABtn } from '../ui'

export default {
    name: 'TwoColsSection',
    components: {
        ABtn,
    },
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    .section-cols {
        &__media {
            width: 100%;
            border-radius: var(--br-1);
            overflow: hidden;
            line-height: 1px;

            @include mobile {
                aspect-ratio: 4/3.5;
            }
        }
        &__left {
            .section-cols__col-inner,
            .section-cols__media {
                height: 100%;
                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        &__right {
            .section-cols__col-inner {
                padding: 16px 0;
            }
        }
        &__content {
            h2 {
                margin-top: 0;
                margin-bottom: 43px;
                @include tablet {
                    margin-bottom: 30px;
                }

                @include tablet {
                    margin-bottom: 24px;
                }
            }
            p {
                font-size: 22px;
                color: var(--c-gray-100);
                line-height: 34px;
                max-width: 450px;

                @include tablet {
                    font-size: 18px;
                    line-height: 28px;
                }
            }
        }
        &__actions {
            margin-top: 36px;
            @include tablet {
                margin-top: 24px;
            }
            @include mobile {
                .a-btn {
                    display: none;
                }
            }
        }
        &__btn-sm.a-btn {
            display: none;
            @include mobile {
                display: inline-flex;
            }
        }
    }
</style>
